<template>

<div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Personal Data</a>

    </h1>
     <div class="text-center" v-if="isLoading">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
<div class="row" v-if="isLoading != true">

<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header"><div class="pic"><img src="../../assets/user-profile.png"/></div> </div>
<div class="panal-body">

  <b-row class="line mt-5">
    <b-col sm="12" md="4"><strong>Internal University : </strong> {{personalData.StudentData[0].UniversityName_EN}} </b-col>
    <b-col sm="12" md="4"><strong>Internal Faculty : </strong>{{personalData.StudentData[0].FacultyName_EN}} </b-col>
   <b-col sm="12"  md="4"><strong>Internal University : </strong> {{personalData.StudentData[0].UniversityName_EN}}  </b-col>
  </b-row>

  <b-row class="line">
   <b-col sm="12" md="3"><strong>First Namen EN: </strong> {{personalData.StudentData[0].FirstNameEN}} </b-col>
    <b-col sm="12" md="3"><strong>Second Name EN: </strong> {{personalData.StudentData[0].SecondNameEN}} </b-col>
    <b-col sm="12" md="3"><strong>Third Name EN: </strong>{{personalData.StudentData[0].ThirdNameEN}} </b-col>
    <b-col sm="12" md="3"><strong>Family Name EN: </strong> {{personalData.StudentData[0].FamilyNameEN}} </b-col>
    <b-col sm="12" md="3"><strong>First Namen AR: </strong> {{personalData.StudentData[0].FirstNameAR}} </b-col>
    <b-col sm="12" md="3"><strong>Second Name AR: </strong>{{personalData.StudentData[0].SecondNameAR}}  </b-col>
    <b-col sm="12" md="3"><strong>Third Name AR: </strong> {{personalData.StudentData[0].ThirdNameAR}} </b-col>
    <b-col sm="12" md="3"><strong>Family Name AR: </strong> {{personalData.StudentData[0].FamilyNameAR}} </b-col>
    <b-col sm="12" md="3"><strong>Nationality: </strong> {{personalData.StudentData[0].NationalityNameEN}} </b-col>
    <b-col sm="12" md="3"><strong>National id: </strong> {{personalData.StudentData[0].NationID}}  </b-col>
    <b-col sm="12" md="3"><strong>Gender: </strong> {{personalData.StudentData[0].GenderName}} </b-col>
    <b-col sm="12" md="3"><strong>Religion: </strong> {{personalData.StudentData[0].ReligionNameEN}}  </b-col>
    <b-col sm="12" md="3"><strong>BirthDate: </strong>{{personalData.StudentData[0].BirthDate}}  </b-col>
    <b-col sm="12" md="3"><strong>BirthPlace: </strong> {{personalData.StudentData[0].BirthPlaceNameEN}}  </b-col>
    <b-col sm="12" md="3"><strong>BirthPlace: </strong> {{personalData.StudentData[0].BirthPlaceNameEN}}  </b-col>
  </b-row>

   <b-row class="line">
   <b-col sm="12" md="12"><h6>Contact  Info</h6></b-col>
    <b-col sm="12" md="4"><strong>Country: </strong> {{personalData.StudentData[0].CountryNameEN}} </b-col>
    <b-col sm="12" md="4"><strong>Governorate: </strong> {{personalData.StudentData[0].GovernorateNameEN}} </b-col>
    <b-col sm="12" md="4"><strong>Address: </strong> {{personalData.StudentData[0].Address}} </b-col>
     <b-col sm="12" md="4"><strong>Email: </strong> {{personalData.StudentEmails[0].ContactDetails}} </b-col>
    <b-col sm="12" md="4"><strong>Phone: </strong> {{personalData.StudentPhones[0].ContactDetails}}</b-col>
   </b-row>

      <b-row class="line">
   <b-col sm="12" md="12"><h6>Education History</h6></b-col>
    <b-col sm="12" md="4"><strong>Certification Type: </strong>{{personalData.StudentEducation[0].CertificationNameEN}}</b-col>
    <b-col sm="12" md="4"><strong>Specialization: </strong>{{personalData.StudentEducation[0].SpecializationNameEN}}</b-col>
    <b-col sm="12" md="4"><strong>Year: </strong> {{personalData.StudentEducation[0].Year}} </b-col>
     <b-col sm="12" md="4"><strong>Enrollment Status: </strong> {{personalData.StudentEducation[0].SpecializationNameEN}} </b-col>
    <b-col sm="12" md="4"><strong>Degree: </strong> {{personalData.StudentEducation[0].Degree}} </b-col>
    <b-col sm="12" md="4"><strong>Percentage: </strong> {{personalData.StudentEducation[0].Percentage}} </b-col>
   </b-row>

         <b-row class="line">
   <b-col sm="12" md="12"><h6>Military Form</h6></b-col>
    <b-col sm="12" md="4"><strong>Military Status: </strong> {{personalData.StudentMilitary[0].StatusNameEN}} </b-col>
    <b-col sm="12" md="4"><strong>Decision Number: </strong> {{personalData.StudentMilitary[0].DecisionNumber}} </b-col>
    <b-col sm="12" md="4"><strong>Decision: </strong> {{personalData.StudentMilitary[0].DecisionText}} </b-col>

   </b-row>


</div>
</div>
</div>
</div>



</div>
</template>
<script>
    import studentData from '../../services/student/studentDataServices';
    export default {
        name: 'PersonalData',
        data(){
            return{
                personalData: '', 
                message:'',
                isLoading : true
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
           studentData.GetStudentData(this.currenUser.StudentID).then(Response =>{
               this.isLoading = false ;
               this.personalData = Response.data
                // eslint-disable-next-line no-console
                //   console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //   console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       },
       

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 10px 10px 10px;
    padding: 20px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 100%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-header .pic{
    width: 100px;
    height:100px;
    border-radius: 50%;
    border: 2px solid #F88400;
    margin: 0 auto;
    margin-bottom:-65px;

}
.panal-header .pic img{
    width:100%;
}
.panal-body{
    padding:20px;
    color:#333;
}
.row .line{
 padding-bottom:10px;
 border-bottom: 1px #646464 dashed;
 margin-top:10px;
 line-height: 2;
}
.row .line:last-child{
    border-bottom: none;
}

</style>
